var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-widget-container" },
    [
      _c(
        "el-form",
        {
          staticClass: "full-height-width widget-form",
          class: [_vm.customClass, _vm.layoutType + "-layout"],
          attrs: {
            "label-position": _vm.labelPosition,
            size: _vm.size,
            "validate-on-rule-change": false,
          },
        },
        [
          _vm.designer.widgetList.length === 0
            ? _c("div", { staticClass: "no-widget-hint" }, [
                _c("i", { staticClass: "el-icon-rank" }),
                _vm._v(
                  " " + _vm._s(_vm.i18nt("designer.noWidgetHint")) + "\n    "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "draggable",
            _vm._b(
              {
                attrs: {
                  list: _vm.designer.widgetList,
                  handle: ".drag-handler",
                  move: _vm.checkMove,
                },
                on: {
                  end: _vm.onDragEnd,
                  add: _vm.onDragAdd,
                  update: _vm.onDragUpdate,
                },
              },
              "draggable",
              { group: "dragGroup", ghostClass: "ghost", animation: 300 },
              false
            ),
            [
              _c(
                "transition-group",
                {
                  staticClass: "form-widget-list",
                  attrs: { name: "fade", tag: "div" },
                },
                [
                  _vm._l(_vm.designer.widgetList, function (widget, index) {
                    return [
                      "container" === widget.category
                        ? [
                            _c(_vm.getWidgetName(widget), {
                              key: widget.id,
                              tag: "component",
                              attrs: {
                                widget: widget,
                                designer: _vm.designer,
                                "parent-list": _vm.designer.widgetList,
                                "index-of-parent-list": index,
                                "parent-widget": null,
                              },
                            }),
                          ]
                        : [
                            _c(_vm.getWidgetName(widget), {
                              key: widget.id,
                              tag: "component",
                              attrs: {
                                field: widget,
                                designer: _vm.designer,
                                "parent-list": _vm.designer.widgetList,
                                "index-of-parent-list": index,
                                "parent-widget": null,
                                "design-state": true,
                              },
                            }),
                          ],
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }